/**
 * MATCH DISPLAY — Badge match% sui card prodotto + breakdown sezione pagina prodotto
 * Pattern Netflix: % onesta, anche bassa, con verdict severo se < 50%
 *
 * Dipendenze: window.FrogMatch (computeMatch, deriveTypologies)
 *             localStorage 'frogmatch_profile_v2'
 *             window.FROGMATCH_PRODUCTS (frogmatch-data-bootstrap snippet)
 */
(function () {
  'use strict';

  const PROFILE_KEY = 'frogmatch_profile_v2';
  const TYPOLOGY_LABELS = {
    eurogame: 'Eurogame', american: 'American', ibrido: 'Ibrido',
    coop: 'Cooperativo', party: 'Party', filler: 'Filler',
    family: 'Family', astratto: 'Astratto', wargame: 'Wargame',
    rollwrite: 'Roll & Write', dungeon: 'Dungeon Crawler',
    legacy: 'Legacy', narrativo: 'Narrativo', asimmetrico: 'Asimmetrico',
    deckbuilder: 'Deckbuilder', dexterity: 'Dexterity', gateway: 'Gateway',
    escape: 'Escape', tricktaking: 'Trick-taking', solo: 'Solo'
  };

  function loadProfile() {
    try {
      const raw = localStorage.getItem(PROFILE_KEY);
      if (!raw) return null;
      const p = JSON.parse(raw);
      if (!p || p.cleared) return null;
      // Profilo deve avere onboarding minimo
      const ok = p.archetypeName || p.bggUsername ||
        (p.topMechanics && p.topMechanics.length > 0) ||
        (p.topTypologies && p.topTypologies.length > 0);
      return ok ? p : null;
    } catch (e) { return null; }
  }

  function loadProducts() {
    const node = document.getElementById('frogmatch-products-data');
    if (!node) return [];
    try {
      return JSON.parse(node.textContent) || [];
    } catch (e) { return []; }
  }

  function findProductByBggOrId(products, bggId, productId) {
    if (bggId) {
      const found = products.find(p => p.bgg && String(p.bgg) === String(bggId));
      if (found) return found;
    }
    if (productId) {
      const found = products.find(p => String(p.id) === String(productId));
      if (found) return found;
    }
    return null;
  }

  // ── 6-tier mapping (allineato a computeMatch v3) ──────────────────
  // Restituiamo SEMPRE il tier dal matchDetail (è già calcolato lì onestamente).
  // Solo fallback per profilo legacy/cache: deriva da pct.
  function tierFromMatch(match) {
    if (match && match.tier) return match.tier;
    const s = match && typeof match.pct === 'number' ? match.pct : 0;
    if (s >= 90) return 'top';
    if (s >= 75) return 'strong';
    if (s >= 60) return 'good';
    if (s >= 45) return 'discover';
    if (s >= 25) return 'distant';
    return 'explore';
  }

  // Mappa tier → classe colore CSS (compatibile con palette esistente).
  // top/strong = verde, good = verde chiaro, discover = giallo, distant/explore = grigio
  function tierColorClass(tier) {
    switch (tier) {
      case 'top':      return 'high';
      case 'strong':   return 'high';
      case 'good':     return 'mid-hi';
      case 'discover': return 'mid';
      case 'distant':  return 'low';
      case 'explore':  return 'low';
      default:         return 'mid';
    }
  }

  function tierLabel(tier) {
    switch (tier) {
      case 'top':      return 'Top per te 🔥';
      case 'strong':   return 'Frog approva 🐸';
      case 'good':     return 'Buona scelta 👍';
      case 'discover': return 'Da scoprire 🧭';
      case 'distant':  return 'Sentiero diverso 🌱';
      case 'explore':  return 'Esplorazione 🌿';
      default:         return 'Da scoprire';
    }
  }

  /**
   * Inietta badge piccolo nelle card prodotto (collection + search).
   */
  function renderBadges(profile, products) {
    const slots = document.querySelectorAll('[data-fp-match-slot]');
    slots.forEach(slot => {
      if (slot.__fpRendered) return;
      slot.__fpRendered = true;
      const bggId = slot.dataset.fpMatchBgg;
      const productId = slot.dataset.fpMatchProductId;
      const product = findProductByBggOrId(products, bggId, productId);
      if (!product) { slot.hidden = true; return; }
      const match = window.FrogMatch && window.FrogMatch.computeMatch
        ? window.FrogMatch.computeMatch(profile, product) : null;
      if (!match) { slot.hidden = true; return; }

      const tier = tierFromMatch(match);
      const colorClass = tierColorClass(tier);
      slot.hidden = false;
      slot.classList.add('fp-match-badge', 'fp-match-badge--' + colorClass, 'fp-match-badge--tier-' + tier);

      // hideNumber = poca confidenza globale O score troppo basso.
      // Niente numero scoraggiante: solo emoji onesto sull'incertezza.
      if (match.hideNumber) {
        const emoji = tier === 'top' ? '🔥'
                    : tier === 'strong' ? '🐸'
                    : tier === 'good' ? '👍'
                    : tier === 'discover' ? '🧭'
                    : tier === 'distant' ? '🌱'
                    : '🌿';
        slot.setAttribute('aria-label', tierLabel(tier) + ' — match da scoprire');
        slot.innerHTML = '<span class="fp-match-badge__num" style="font-size:1.05em">' + emoji + '</span>';
      } else {
        const score = Math.max(0, Math.min(100, Math.round(match.pct)));
        slot.setAttribute('aria-label', score + '% match per te — ' + tierLabel(tier));
        slot.innerHTML = '<span class="fp-match-badge__num">' + score + '<span class="fp-match-badge__pct">%</span></span>';
      }
    });
  }

  /**
   * Card breakdown nella pagina prodotto: collassata, espandibile.
   */
  function renderProductPageBreakdown(profile, products) {
    const slot = document.querySelector('[data-fp-match-product-page]');
    if (!slot || slot.__fpRendered) return;
    slot.__fpRendered = true;

    const bggId = slot.dataset.fpMatchBgg;
    const productId = slot.dataset.fpMatchProductId;
    const product = findProductByBggOrId(products, bggId, productId);
    if (!product) {
      // Prodotto non nel catalogo BGG (metafield mancanti): mostra fallback informativo
      slot.hidden = false;
      slot.classList.add('fp-match-card', 'fp-match-card--unavail');
      slot.innerHTML =
        '<div class="fp-match-card__head fp-match-card__head--static">' +
          '<span class="fp-match-card__num-wrap"><span class="fp-match-card__num" style="font-size:1.5rem">🐸</span></span>' +
          '<span class="fp-match-card__head-text">' +
            '<span class="fp-match-card__label">Match non disponibile</span>' +
            '<span class="fp-match-card__sub">Questo gioco non ha ancora i dati BGG completi per il calcolo</span>' +
          '</span>' +
        '</div>';
      return;
    }

    const match = window.FrogMatch && window.FrogMatch.computeMatch
      ? window.FrogMatch.computeMatch(profile, product) : null;
    if (!match) { slot.hidden = true; return; }

    const tier = tierFromMatch(match);
    const colorClass = tierColorClass(tier);
    const label = tierLabel(tier);
    const parts = match.parts || {};
    const hideNumber = !!match.hideNumber;
    const hideReason = match.hideReason; // 'low_confidence' | 'low_score' | null
    const score = hideNumber ? null : Math.max(0, Math.min(100, Math.round(match.pct)));

    // Costruisci sezioni positivi e negativi (riusa logica esistente: legge parts.*)
    const positives = buildPositives(profile, product, parts);
    const negatives = buildNegatives(profile, product, parts);
    // Caratteristiche oggettive del gioco: interaction + alea + peso (informative,
    // sempre mostrate, non dipendono dal match con profilo utente)
    const gameTraits = buildGameTraits(profile, product);
    // Verdict basato sul tier + reason (per distinguere "low confidence" vs "low score")
    const verdict = buildVerdictByTier(tier, hideNumber, hideReason);

    // Numero header: o il display %, o un'emoji se hideNumber
    const headerNum = hideNumber
      ? (tier === 'top' ? '🔥' : tier === 'strong' ? '🐸' : tier === 'good' ? '👍'
         : tier === 'discover' ? '🧭' : tier === 'distant' ? '🌱' : '🌿')
      : score;
    const headerPctTag = hideNumber ? '' : '<span class="fp-match-card__pct">%</span>';
    // Sub-text differenzia: poco profilo vs match basso onesto vs match espandibile
    let subText;
    if (hideReason === 'low_confidence') {
      subText = 'Servono più segnali sul tuo profilo · Tap per scoprire';
    } else if (hideReason === 'low_score') {
      subText = 'Fuori dal tuo solco abituale · Tap per scoprire';
    } else {
      subText = 'Tap per scoprire perché';
    }

    // Contenuto del MODAL (riusa positives/negatives/gameTraits/verdict + meta)
    const metaHtml =
      '<div class="fp-match-modal__meta">' +
        '<p>📊 Calcolato sui tuoi <strong>' +
          ((profile.sample && profile.sample.loved) || profile.bggLovedCount || 'pochi') +
        '</strong> swipe' +
        ((profile.playsActivity && profile.playsActivity.totalPlays) ? ' + <strong>' + profile.playsActivity.totalPlays + '</strong> partite loggate' : '') +
        ((profile.bggOwnedCount) ? ' + <strong>' + profile.bggOwnedCount + '</strong> giochi posseduti' : '') +
        ((profile.purchasedProducts && profile.purchasedProducts.length) ? ' + <strong>' + profile.purchasedProducts.length + '</strong> acquisti Frogames' : '') +
        '.</p>' +
        '<p>🔄 <strong>Più giochi → match più precisi.</strong> Ogni partita registrata, sync BGG, acquisto e gioco simile dei Frogger come te affina i suggerimenti.</p>' +
      '</div>';

    const modalHtml =
      '<div class="fp-match-modal__head">' +
        '<span class="fp-match-modal__num">' + headerNum + headerPctTag + '</span>' +
        '<span><span class="fp-match-modal__label">' + label + '</span></span>' +
      '</div>' +
      (positives.length > 0 ? '<div class="fp-match-modal__sec"><h4>✅ Cosa funziona per te</h4><ul>' + positives.map(p => '<li>' + p + '</li>').join('') + '</ul></div>' : '') +
      (negatives.length > 0 ? '<div class="fp-match-modal__sec"><h4>⚠️ Da considerare</h4><ul>' + negatives.map(p => '<li>' + p + '</li>').join('') + '</ul></div>' : '') +
      (gameTraits.length > 0 ? '<div class="fp-match-modal__sec"><h4>🎮 Caratteristiche del gioco</h4><ul>' + gameTraits.map(t => '<li>' + t + '</li>').join('') + '</ul></div>' : '') +
      (verdict ? '<div class="fp-match-modal__verdict"><h4>🐸 Il parere di Frog</h4><p>' + verdict + '</p></div>' : '') +
      metaHtml;

    // PILL compatta (in alto a destra) → apre il modal
    slot.hidden = false;
    slot.classList.add('fp-match-pill', 'fp-match-pill--' + colorClass, 'fp-match-pill--tier-' + tier);
    slot.innerHTML =
      '<button type="button" class="fp-match-pill__btn" data-fp-match-open aria-haspopup="dialog">' +
        '<span class="fp-match-pill__num">' + headerNum + headerPctTag + '</span>' +
        '<span class="fp-match-pill__tx">' +
          '<span class="fp-match-pill__label">FrogMatch 🐸</span>' +
          '<span class="fp-match-pill__sub">' + label + '</span>' +
        '</span>' +
        '<span class="fp-match-pill__chev">▸</span>' +
      '</button>';

    const openBtn = slot.querySelector('[data-fp-match-open]');
    if (openBtn) openBtn.addEventListener('click', function () { openFpMatchModal(modalHtml); });
  }

  // ===== Modal FrogMatch (apertura/chiusura intelligenti: X, click fuori, ESC, scroll lock) =====
  function ensureFpModal() {
    let ov = document.getElementById('fp-match-modal');
    if (ov) return ov;
    ov = document.createElement('div');
    ov.id = 'fp-match-modal';
    ov.className = 'fp-match-modal';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.setAttribute('aria-label', 'FrogMatch');
    ov.innerHTML = '<div class="fp-match-modal__dialog"><button type="button" class="fp-match-modal__x" aria-label="Chiudi">✕</button><div class="fp-match-modal__content"></div></div>';
    document.body.appendChild(ov);
    ov.addEventListener('click', function (e) { if (e.target === ov) closeFpMatchModal(); }); // click fuori
    ov.querySelector('.fp-match-modal__x').addEventListener('click', closeFpMatchModal);       // X
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && ov.classList.contains('is-open')) closeFpMatchModal(); }); // ESC
    return ov;
  }
  function openFpMatchModal(html) {
    const ov = ensureFpModal();
    ov.querySelector('.fp-match-modal__content').innerHTML = html;
    ov.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeFpMatchModal() {
    const ov = document.getElementById('fp-match-modal');
    if (!ov) return;
    ov.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function buildPositives(profile, product, parts) {
    const out = [];
    const productTyps = window.FrogMatch && window.FrogMatch.deriveTypologies
      ? window.FrogMatch.deriveTypologies(product) : [];
    const userTyps = profile.topTypologiesPrimary || profile.topTypologies || [];
    const sharedTyps = userTyps.filter(t => productTyps.includes(t));
    if (sharedTyps.length > 0 && parts.typologyPrimary > 0) {
      const labels = sharedTyps.map(t => TYPOLOGY_LABELS[t] || t).join(', ');
      out.push('<strong>' + labels + '</strong>: tra le tue tipologie preferite');
    }
    const mShared = (profile.topMechanics || []).filter(m => (product.mch || []).includes(m));
    if (mShared.length > 0 && parts.mechanics > 0) {
      const tMech = (window.FrogMatch && window.FrogMatch.tMech) ? window.FrogMatch.tMech : (s) => s;
      // Mostra TUTTE le meccaniche condivise — niente "+N altre" che nasconderebbe info utile
      const list = mShared.map(m => tMech(m)).join(' · ');
      out.push('<strong>' + mShared.length + ' meccanic' + (mShared.length === 1 ? 'a' : 'he') + ' in comune</strong> con i tuoi gusti: ' + list);
    }
    const cShared = (profile.topCategories || []).filter(c => (product.cat || []).includes(c));
    if (cShared.length > 0 && parts.categories > 0) {
      const tCat = (window.FrogMatch && window.FrogMatch.tCat) ? window.FrogMatch.tCat : (s) => s;
      const list = cShared.map(c => tCat(c)).join(' · ');
      out.push('<strong>' + cShared.length + ' categori' + (cShared.length === 1 ? 'a' : 'e') + ' in comune</strong>: ' + list);
    }
    // Thresholds allineati ai cap v3 — NB: peso/durata/interaction/alea/rating BGG
    // sono ora nella sezione "🎮 Caratteristiche del gioco" con inline match-tag.
    // Qui in positivi teniamo solo il numero giocatori (match diretto col profilo).
    if (parts.players >= 5) {
      out.push('Numero giocatori <strong>ideale</strong> per il tuo tavolo');
    }
    if (parts.ownershipBoost) {
      if (parts.ownedFrogames && parts.ownedBgg) {
        out.push('📚 <strong>Già nel tuo scaffale</strong> — acquistato qui da noi.');
      } else if (parts.ownedFrogames) {
        out.push('🛍 <strong>Già nel tuo scaffale Frogames</strong> — l\'hai acquistato qui.');
      } else if (parts.ownedBgg) {
        out.push('📚 <strong>Già nella tua collezione</strong> — l\'hai segnato come posseduto su BGG.');
      } else if (parts.ownedManual) {
        out.push('🎲 <strong>Già nella tua ludoteca</strong> — l\'hai aggiunto manualmente al tuo scaffale.');
      }
    }
    // v3: playedBoost — segnala che il sistema sa che hai giocato questo gioco.
    // 3 lookup in cascata: topPlayed → manualPlays → fallback "1 volta".
    if (parts.playedBoost) {
      let plays = 0;
      // 1) topPlayed (entry aggregata enriched)
      const tpArr = profile.playsActivity?.topPlayed;
      if (Array.isArray(tpArr)) {
        const tp = tpArr.find(g =>
          (product.bgg && g.bggId === product.bgg) ||
          (product.id && String(g.productId) === String(product.id))
        );
        if (tp) plays = tp.plays || 0;
      }
      // 2) manualPlays (singole partite a root), conta le occorrenze
      if (plays === 0 && Array.isArray(profile.manualPlays)) {
        plays = profile.manualPlays.filter(p =>
          (product.bgg && p.bggId === product.bgg) ||
          (product.id && String(p.productId) === String(product.id))
        ).length;
      }
      if (plays === 0) plays = 1; // fallback minimo (playedBoost esiste = almeno 1 partita)
      out.push('🎲 <strong>Ci hai giocato ' + plays + ' ' + (plays === 1 ? 'volta' : 'volte') + '</strong> — segnale forte di interesse');
    }
    return out;
  }

  function buildNegatives(profile, product, parts) {
    const out = [];
    // Avoided mechanics — callout esplicito (negativo REALE: l'utente ha detto "no" al quiz).
    // È l'UNICO negativo qui: peso/durata/interaction/alea finiscono come tag inline
    // nella sezione "🎮 Caratteristiche del gioco", senza duplicazione.
    const avoidedHits = (profile.avoidedMechanics || []).filter(a => (product.mch || []).includes(a));
    if (avoidedHits.length > 0) {
      const tMech = (window.FrogMatch && window.FrogMatch.tMech) ? window.FrogMatch.tMech : (s) => s;
      const tradotti = avoidedHits.slice(0, 2).map(a => tMech(a)).join(', ');
      out.push('<strong>Contiene ' + tradotti + '</strong>: meccanic' + (avoidedHits.length === 1 ? 'a che hai' : 'he che hai') + ' escluso durante il quiz');
    }
    return out;
  }

  // ──────────────────────────────────────────────────────────────────────
  // Caratteristiche oggettive del gioco (interaction + alea + peso + durata).
  // SEMPRE mostrate quando i dati ci sono, indipendentemente dal match col profilo.
  // Risponde alla domanda "che TIPO di gioco è" non "matcha o no col mio gusto".
  // ──────────────────────────────────────────────────────────────────────
  function buildGameTraits(profile, product) {
    const out = [];
    const FM = window.FrogMatch;
    if (!FM) return out;

    // Helper per il tag inline che confronta il valore con la preferenza utente
    function matchTag(distance, matchText, mismatchText) {
      if (distance == null) return '';
      if (distance === 0) return ' <em class="fp-match-trait-match">' + matchText + '</em>';
      if (distance >= 3) return ' <em class="fp-match-trait-mismatch">' + mismatchText + '</em>';
      if (distance === 2) return ' <em class="fp-match-trait-soft">· un po\' distante</em>';
      return '';
    }

    // Interazione
    if (typeof FM.deriveInteraction === 'function') {
      const level = FM.deriveInteraction(product);
      if (level != null && FM.INTERACTION_LABELS) {
        const icon = (FM.INTERACTION_ICONS && FM.INTERACTION_ICONS[level]) || '';
        const label = FM.INTERACTION_LABELS[level] || '';
        const dist = profile.interactionPreference != null
          ? Math.abs(level - profile.interactionPreference) : null;
        out.push(icon + ' <strong>Interazione</strong>: ' + label + matchTag(dist, '· nel tuo stile', '· opposto al tuo'));
      }
    }

    // Alea
    if (typeof FM.deriveAlea === 'function') {
      const level = FM.deriveAlea(product);
      if (level != null && FM.ALEA_LABELS) {
        const icon = (FM.ALEA_ICONS && FM.ALEA_ICONS[level]) || '';
        const label = FM.ALEA_LABELS[level] || '';
        const dist = profile.aleaPreference != null
          ? Math.abs(level - profile.aleaPreference) : null;
        out.push(icon + ' <strong>Alea</strong>: ' + label + matchTag(dist, '· come la preferisci', '· opposto al tuo'));
      }
    }

    // Complessità (peso BGG) con inline match tag vs weightTarget utente
    if (product.w && product.w > 0) {
      let weightLabel;
      if (product.w < 1.5) weightLabel = 'Molto leggero';
      else if (product.w < 2.2) weightLabel = 'Leggero';
      else if (product.w < 3.0) weightLabel = 'Medio';
      else if (product.w < 3.8) weightLabel = 'Medio-pesante';
      else weightLabel = 'Pesante';
      let weightMatch = '';
      if (profile.weightTarget != null) {
        const diff = Math.abs(product.w - profile.weightTarget);
        if (diff < 0.5) weightMatch = ' <em class="fp-match-trait-match">· nel tuo target</em>';
        else if (diff >= 1.5) {
          const dir = product.w > profile.weightTarget ? 'più pesante' : 'più leggero';
          weightMatch = ' <em class="fp-match-trait-mismatch">· ' + dir + ' del tuo</em>';
        } else if (diff >= 1.0) {
          weightMatch = ' <em class="fp-match-trait-soft">· un po\' distante</em>';
        }
      }
      out.push('🧠 <strong>Complessità</strong>: ' + weightLabel + ' (' + product.w.toFixed(1) + '/5)' + weightMatch);
    }

    // Durata con inline match tag vs playtimeTarget utente
    if (product.tmin && product.tmax) {
      const dur = product.tmin === product.tmax ? product.tmax + ' min' : product.tmin + '-' + product.tmax + ' min';
      let durMatch = '';
      if (profile.playtimeTarget) {
        const targetMid = (profile.playtimeTarget[0] + profile.playtimeTarget[1]) / 2;
        const productMid = (product.tmin + product.tmax) / 2;
        const diffMin = Math.abs(targetMid - productMid);
        if (diffMin < 20) durMatch = ' <em class="fp-match-trait-match">· nel tuo range</em>';
        else if (diffMin >= 60) {
          const dir = productMid > targetMid ? 'più lungo' : 'più corto';
          durMatch = ' <em class="fp-match-trait-mismatch">· ' + dir + ' del solito</em>';
        } else if (diffMin >= 40) {
          durMatch = ' <em class="fp-match-trait-soft">· fuori dal tuo solito</em>';
        }
      }
      out.push('⏱️ <strong>Durata</strong>: ' + dur + durMatch);
    }

    // Rating BGG — fatto oggettivo, niente match-tag (non si confronta col profilo)
    if (product.rt && product.rt > 0) {
      out.push('⭐ <strong>BGG Rating</strong>: ' + product.rt.toFixed(1) + '/10');
    }

    return out;
  }

  // Verdict per tier (allineato a computeMatch v3 — 6 livelli).
  // Mai "Frog passa": anche distant/explore è incorniciato come opportunità, non come bocciatura.
  function buildVerdictByTier(tier, hideNumber, hideReason) {
    if (hideNumber && hideReason === 'low_confidence') {
      return 'Ci servono ancora un po\' di segnali sul tuo profilo (swipe, partite, acquisti) per darti un numero affidabile. 🌿 Intanto, <strong>se ti incuriosisce è un buon momento per scoprirlo</strong>.';
    }
    if (hideNumber && hideReason === 'low_score') {
      return 'Su carta questo gioco è fuori dal tuo solco abituale: <strong>meccaniche/categorie diverse da quelle che ti piacciono di solito</strong>. 🌱 Ma il "fuori solco" è anche dove ogni tanto si scopre il prossimo preferito.';
    }
    switch (tier) {
      case 'top':
        return 'Sembra <strong>cucito addosso</strong> ai tuoi gusti. 🔥 Frog ti darebbe il cinque al tavolo.';
      case 'strong':
        return 'Parlate la stessa lingua: <strong>sa di te</strong>. 🐸 Lo stagno te lo prepara col fiocco.';
      case 'good':
        return 'Nel tuo ritmo. 👍 <strong>Una buona scelta</strong> per chi ama variare un po\'.';
      case 'discover':
        return 'Una zona inesplorata del tuo gusto. 🧭 <strong>Potrebbe sorprenderti</strong> in modo gentile.';
      case 'distant':
        return 'Non è la tua tazza di tè abituale 🌱 — ma <strong>i giochi che ci spiazzano sono spesso quelli che restano</strong>.';
      case 'explore':
      default:
        return 'Un sentiero diverso dai tuoi soliti. 🌿 Se ti incuriosisce, <strong>è proprio così che si scoprono nuovi mondi al tavolo</strong>.';
    }
  }

  let initDone = false;
  function primeCaches(profile, products) {
    // Migrazione retroattiva tag legacy (asimmetrico/solo errati) anche su collection/product
    try {
      if (window.FrogMatch && window.FrogMatch.applySoloGamerTag) {
        const before = (profile.topTypologies || []).join(',');
        window.FrogMatch.applySoloGamerTag(profile, products);
        const after = (profile.topTypologies || []).join(',');
        if (before !== after) {
          // Salvataggio per persistere migrazione
          try { window.FrogMatch.saveProfile && window.FrogMatch.saveProfile(profile); } catch (e) {}
        }
      }
    } catch (e) { /* silenzioso */ }
    // Popola cache locali (heavilyPlayedMech, fourFavoritesMech) chiamando rankProducts.
    try {
      if (window.FrogMatch && window.FrogMatch.rankProducts) {
        window.FrogMatch.rankProducts(profile, products);
      }
    } catch (e) { /* silenzioso */ }
  }

  function loadCommunitySignal() {
    // Community signal: "Frogger come te giocano X → boost X". Async, non blocca rendering.
    // Quando arriva, ri-renderizza match con boost community incluso.
    try {
      if (!window.FrogMatch || !window.FrogMatch.loadCommunityData) return;
      const node = document.getElementById('frogmatch-customer-data');
      let workerUrl = null;
      if (node) {
        try {
          const c = JSON.parse(node.textContent);
          workerUrl = c && c.workerUrl;
        } catch (e) {}
      }
      if (!workerUrl) workerUrl = 'https://froghunt.info-frogames.workers.dev';
      window.FrogMatch.loadCommunityData(workerUrl, 30).then(data => {
        if (!data) return;
        // Re-render con boost community attivo
        document.querySelectorAll('[data-fp-match-slot]').forEach(s => { delete s.__fpRendered; });
        document.querySelectorAll('[data-fp-match-product-page]').forEach(s => { delete s.__fpRendered; });
        const profile = loadProfile();
        const products = loadProducts();
        if (profile && products.length) {
          renderBadges(profile, products);
          renderProductPageBreakdown(profile, products);
        }
      });
    } catch (e) { /* silenzioso */ }
  }

  function init() {
    if (initDone) return;
    const profile = loadProfile();
    if (!profile) { initDone = true; return; } // utente anonimo / no onboarding → niente badge
    const products = loadProducts();
    if (!products.length) { initDone = true; return; }
    if (!window.FrogMatch || !window.FrogMatch.computeMatch) {
      // Aspetta che frogmatch.js sia caricato (timeout 10s)
      let tries = 0;
      const interval = setInterval(() => {
        tries++;
        if (window.FrogMatch && window.FrogMatch.computeMatch) {
          clearInterval(interval);
          initDone = true;
          primeCaches(profile, products);
          renderBadges(profile, products);
          renderProductPageBreakdown(profile, products);
          loadCommunitySignal();
        }
        if (tries > 100) clearInterval(interval); // 10s timeout
      }, 100);
      return;
    }
    initDone = true;
    primeCaches(profile, products);
    renderBadges(profile, products);
    renderProductPageBreakdown(profile, products);
    // Async: carica community signal e ri-renderizza con boost incluso
    loadCommunitySignal();
  }

  // Esposto globalmente per debug e re-trigger manuale
  window.fpMatchInit = function () { initDone = false; init(); };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Backup trigger: dopo che TUTTI i defer scripts sono caricati
  window.addEventListener('load', () => {
    if (!initDone) init();
  });
  // Re-init dopo Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-fp-match-slot]').forEach(s => { delete s.__fpRendered; });
    document.querySelectorAll('[data-fp-match-product-page]').forEach(s => { delete s.__fpRendered; });
    initDone = false;
    init();
  });

  // ══════════════════════════════════════════════════════════════════════════
  // Helper unificato per forzare il re-render delle card match%
  // (usato da: profile-updated, pageshow bfcache, storage event cross-tab,
  //  e qualsiasi altro trigger di invalidazione)
  // ══════════════════════════════════════════════════════════════════════════
  function forceRerender() {
    document.querySelectorAll('[data-fp-match-slot]').forEach(s => { delete s.__fpRendered; });
    document.querySelectorAll('[data-fp-match-product-page]').forEach(s => {
      delete s.__fpRendered;
      // Rimuovi classi residue tier-*/--high/--mid-hi/--mid/--low per evitare colori vecchi
      s.className = (s.className || '').replace(/\bfp-match-card[\w-]*/g, '').trim();
      s.innerHTML = '';
    });
    initDone = false;
    init();
  }

  // ── Re-render quando il profilo viene aggiornato (log/edit/delete play, swipe, sync) ──
  let profileUpdateDebounce = null;
  window.addEventListener('frogmatch:profile-updated', () => {
    if (profileUpdateDebounce) clearTimeout(profileUpdateDebounce);
    profileUpdateDebounce = setTimeout(() => {
      profileUpdateDebounce = null;
      forceRerender();
    }, 200);
  });

  // ── bfcache: navigazione back/forward ──
  // Quando il browser usa bfcache, DOMContentLoaded NON scatta. L'evento `pageshow`
  // con event.persisted=true ci dice che siamo in bfcache → forziamo re-render
  // perché il profilo potrebbe essere cambiato in un'altra tab nel frattempo.
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      // Pagina restored da bfcache: forza il re-check del profilo
      forceRerender();
    }
  });

  // ── Cross-tab sync: localStorage cambia in un'altra tab ──
  // Se l'utente logga una partita in Tab A e ha Tab B aperto su un product page,
  // l'evento storage scatta in Tab B → re-render.
  window.addEventListener('storage', (event) => {
    if (event.key === 'frogmatch_profile_v2' && event.newValue) {
      if (profileUpdateDebounce) clearTimeout(profileUpdateDebounce);
      profileUpdateDebounce = setTimeout(() => {
        profileUpdateDebounce = null;
        forceRerender();
      }, 200);
    }
  });

  // ── Soft-navigation Shopify (Liquid AJAX / theme transitions) ──
  // Alcuni temi Shopify usano section:load / section:reorder per soft-nav.
  // Già gestiti sopra in `shopify:section:load`. Aggiungiamo anche page:loaded
  // dei tema Dawn-derivati che hanno turbo-style nav.
  document.addEventListener('page:loaded', forceRerender);
  document.addEventListener('shopify:page:loaded', forceRerender);

  // ── Profile freshness check ad ogni focus ──
  // Caso d'uso: l'utente apre product page, va a loggare partita in altra tab,
  // torna a product page (focus). Senza questo controllo vedrebbe il match
  // vecchio finché non refreshia. Il check legge updatedAt e re-renderizza
  // solo se è effettivamente cambiato dal load.
  let lastSeenUpdatedAt = null;
  function getProfileUpdatedAt() {
    try {
      const raw = localStorage.getItem(PROFILE_KEY);
      if (!raw) return null;
      const p = JSON.parse(raw);
      return p && p.updatedAt ? p.updatedAt : null;
    } catch (e) { return null; }
  }
  // Registra updatedAt iniziale dopo che init() ha avuto modo di renderizzare
  setTimeout(() => { lastSeenUpdatedAt = getProfileUpdatedAt(); }, 500);
  window.addEventListener('focus', () => {
    const now = getProfileUpdatedAt();
    if (now && lastSeenUpdatedAt && now !== lastSeenUpdatedAt) {
      lastSeenUpdatedAt = now;
      forceRerender();
    } else if (now && !lastSeenUpdatedAt) {
      lastSeenUpdatedAt = now;
    }
  });
  // Update il puntatore quando saveProfile ha appena fatto save
  window.addEventListener('frogmatch:profile-updated', () => {
    lastSeenUpdatedAt = getProfileUpdatedAt();
  });

  // MutationObserver per card aggiunte tardi (lazy load, infinite scroll, paginazione AJAX)
  let observerDebounce = null;
  const obs = new MutationObserver(() => {
    if (observerDebounce) return;
    observerDebounce = setTimeout(() => {
      observerDebounce = null;
      // Re-render solo gli slot ancora vuoti (innerHTML.length === 0)
      const profile = loadProfile();
      const products = loadProducts();
      if (!profile || !products.length || !window.FrogMatch) return;
      const newSlots = document.querySelectorAll('[data-fp-match-slot]:empty');
      if (newSlots.length === 0) return;
      newSlots.forEach(s => { delete s.__fpRendered; });
      renderBadges(profile, products);
    }, 200);
  });
  if (document.body) {
    obs.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', () => {
      obs.observe(document.body, { childList: true, subtree: true });
    });
  }
})();
